// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.xFS4J_03qcS4lzfTYmjR {
  width: 24px;
  height: 45px;
  position: relative;
  margin: auto;
  -webkit-transform: rotate(0deg);
  -moz-transform: rotate(0deg);
  -o-transform: rotate(0deg);
  transform: rotate(0deg);
  -webkit-transition: .5s ease-in-out;
  -moz-transition: .5s ease-in-out;
  -o-transition: .5s ease-in-out;
  transition: .5s ease-in-out;
  cursor: pointer;
}

.xFS4J_03qcS4lzfTYmjR span {
  display: block;
  position: absolute;
  height: 3px;
  width: 100%;
  background: #000;
  border-radius: 9px;
  opacity: 1;
  left: 0;
  -webkit-transform: rotate(0deg);
  -moz-transform: rotate(0deg);
  -o-transform: rotate(0deg);
  transform: rotate(0deg);
  -webkit-transition: .25s ease-in-out;
  -moz-transition: .25s ease-in-out;
  -o-transition: .25s ease-in-out;
  transition: .25s ease-in-out;
}

.xFS4J_03qcS4lzfTYmjR span:nth-child(1) {
  top: 10px;
  -webkit-transform-origin: left center;
  -moz-transform-origin: left center;
  -o-transform-origin: left center;
  transform-origin: left center;
}

.xFS4J_03qcS4lzfTYmjR span:nth-child(2) {
  top: 18px;
  -webkit-transform-origin: left center;
  -moz-transform-origin: left center;
  -o-transform-origin: left center;
  transform-origin: left center;
}

.xFS4J_03qcS4lzfTYmjR span:nth-child(3) {
  top: 26px;
  -webkit-transform-origin: left center;
  -moz-transform-origin: left center;
  -o-transform-origin: left center;
  transform-origin: left center;
}

.xFS4J_03qcS4lzfTYmjR.nago_UjhVNkJKha8NdZV span:nth-child(1) {
  -webkit-transform: rotate(45deg);
  -moz-transform: rotate(45deg);
  -o-transform: rotate(45deg);
  transform: rotate(45deg);
  top: 11px;
  left: 4px;
}

.xFS4J_03qcS4lzfTYmjR.nago_UjhVNkJKha8NdZV span:nth-child(2) {
  width: 0%;
  opacity: 0;
}

.xFS4J_03qcS4lzfTYmjR.nago_UjhVNkJKha8NdZV span:nth-child(3) {
  -webkit-transform: rotate(-45deg);
  -moz-transform: rotate(-45deg);
  -o-transform: rotate(-45deg);
  transform: rotate(-45deg);
  top: 28px;
  left: 4px;
}
`, "",{"version":3,"sources":["webpack://./src/components/Navigation/MenuBurgerIcon/MenuBurgerIcon.module.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,YAAY;EACZ,+BAA+B;EAC/B,4BAA4B;EAC5B,0BAA0B;EAC1B,uBAAuB;EACvB,mCAAmC;EACnC,gCAAgC;EAChC,8BAA8B;EAC9B,2BAA2B;EAC3B,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,WAAW;EACX,WAAW;EACX,gBAAgB;EAChB,kBAAkB;EAClB,UAAU;EACV,OAAO;EACP,+BAA+B;EAC/B,4BAA4B;EAC5B,0BAA0B;EAC1B,uBAAuB;EACvB,oCAAoC;EACpC,iCAAiC;EACjC,+BAA+B;EAC/B,4BAA4B;AAC9B;;AAEA;EACE,SAAS;EACT,qCAAqC;EACrC,kCAAkC;EAClC,gCAAgC;EAChC,6BAA6B;AAC/B;;AAEA;EACE,SAAS;EACT,qCAAqC;EACrC,kCAAkC;EAClC,gCAAgC;EAChC,6BAA6B;AAC/B;;AAEA;EACE,SAAS;EACT,qCAAqC;EACrC,kCAAkC;EAClC,gCAAgC;EAChC,6BAA6B;AAC/B;;AAEA;EACE,gCAAgC;EAChC,6BAA6B;EAC7B,2BAA2B;EAC3B,wBAAwB;EACxB,SAAS;EACT,SAAS;AACX;;AAEA;EACE,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,iCAAiC;EACjC,8BAA8B;EAC9B,4BAA4B;EAC5B,yBAAyB;EACzB,SAAS;EACT,SAAS;AACX","sourcesContent":[".burger {\n  width: 24px;\n  height: 45px;\n  position: relative;\n  margin: auto;\n  -webkit-transform: rotate(0deg);\n  -moz-transform: rotate(0deg);\n  -o-transform: rotate(0deg);\n  transform: rotate(0deg);\n  -webkit-transition: .5s ease-in-out;\n  -moz-transition: .5s ease-in-out;\n  -o-transition: .5s ease-in-out;\n  transition: .5s ease-in-out;\n  cursor: pointer;\n}\n\n.burger span {\n  display: block;\n  position: absolute;\n  height: 3px;\n  width: 100%;\n  background: #000;\n  border-radius: 9px;\n  opacity: 1;\n  left: 0;\n  -webkit-transform: rotate(0deg);\n  -moz-transform: rotate(0deg);\n  -o-transform: rotate(0deg);\n  transform: rotate(0deg);\n  -webkit-transition: .25s ease-in-out;\n  -moz-transition: .25s ease-in-out;\n  -o-transition: .25s ease-in-out;\n  transition: .25s ease-in-out;\n}\n\n.burger span:nth-child(1) {\n  top: 10px;\n  -webkit-transform-origin: left center;\n  -moz-transform-origin: left center;\n  -o-transform-origin: left center;\n  transform-origin: left center;\n}\n\n.burger span:nth-child(2) {\n  top: 18px;\n  -webkit-transform-origin: left center;\n  -moz-transform-origin: left center;\n  -o-transform-origin: left center;\n  transform-origin: left center;\n}\n\n.burger span:nth-child(3) {\n  top: 26px;\n  -webkit-transform-origin: left center;\n  -moz-transform-origin: left center;\n  -o-transform-origin: left center;\n  transform-origin: left center;\n}\n\n.burger.open span:nth-child(1) {\n  -webkit-transform: rotate(45deg);\n  -moz-transform: rotate(45deg);\n  -o-transform: rotate(45deg);\n  transform: rotate(45deg);\n  top: 11px;\n  left: 4px;\n}\n\n.burger.open span:nth-child(2) {\n  width: 0%;\n  opacity: 0;\n}\n\n.burger.open span:nth-child(3) {\n  -webkit-transform: rotate(-45deg);\n  -moz-transform: rotate(-45deg);\n  -o-transform: rotate(-45deg);\n  transform: rotate(-45deg);\n  top: 28px;\n  left: 4px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"burger": `xFS4J_03qcS4lzfTYmjR`,
	"open": `nago_UjhVNkJKha8NdZV`
};
export default ___CSS_LOADER_EXPORT___;
